import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

// --- Background Images ---
import isForYouBg from "../assets/images/is-for-you-bg.jpeg";
import willHelpYouBg from "../assets/images/will-help-you-bg.jpeg";

// --- Feature Icons ---
import featureIcon1 from "../assets/images/feature-icon-1.png";
import featureIcon2 from "../assets/images/feature-icon-2.png";
import featureIcon3 from "../assets/images/feature-icon-3.png";
import featureIcon4 from "../assets/images/feature-icon-4.png";
import featureIcon5 from "../assets/images/feature-icon-5.png";
import featureIcon6 from "../assets/images/feature-icon-6.png";
import featureIcon7 from "../assets/images/feature-icon-7.png";

// --- Video Assets ---
import video1 from "../assets/videos/testimonial-video1.mp4";
import video2 from "../assets/videos/testimonial-video2.mp4";
import video3 from "../assets/videos/testimonial-video3.mp4";

// --- Video Poster Images ---
import posterVideo1 from "../assets/images/poster-video1.png";
import posterVideo2 from "../assets/images/poster-video2.png";
import posterVideo3 from "../assets/images/poster-video3.png";

// --- Screenshot Assets ---
import screenshot1 from "../assets/screenshots/screenshot1.jpeg";
import screenshot2 from "../assets/screenshots/screenshot2.jpeg";
import screenshot3 from "../assets/screenshots/screenshot3.jpeg";

// featureitems images:
import featureImg1 from "../assets/images/feature-1.jpeg";
import featureImg2 from "../assets/images/feature-2.jpeg";
import featureImg3 from "../assets/images/feature-3.jpeg";
import featureImg4 from "../assets/images/feature-4.jpeg";
import featureImg5 from "../assets/images/feature-5.jpeg";
import featureImg6 from "../assets/images/feature-6.jpeg";
import featureImg7 from "../assets/images/feature-7.jpeg";

import logoUrl from "../assets/images/logo.png"; // Import the logo image
// Add this helper component for the Italian flag emoji
// const ItalianFlagIcon = () => (
//   <span role="img" aria-label="Italian flag">
//     🇮🇹
//   </span>
// );

export const CONTENT = {
  navbar: {
    logo: "MetodoALPS",
    links: [
      { name: "Home", to: "home" },
      { name: "Metodo", to: "offerings" },
      { name: "Chi Sono", to: "about" },
      { name: "Per Chi È", to: "per-chi" },
      { name: "Testimonianze", to: "testimonials" },
    ],
    cta: "Lista d’attesa", // This will link to the register section
  },
  hero: {
    // Both halves are existing brand vocabulary from the method copy.
    eyebrow: "Metodo ALPS · science based",
    /*
      The headline is art-directed, not wrapped. The words are unchanged —
      "Da quanto tempo cerchi di parlare meglio in italiano senza risultati?" —
      but they are set as four deliberate lines so the question opens quietly,
      swells through the middle, and lands on the phrase that carries the
      whole promise. `lead` is the quiet opener, `main` the full-size body of
      the question, `accent` the emphasised payload.
    */
    title: {
      lead: "Da quanto tempo",
      main: ["cerchi di parlare", "meglio in italiano"],
      accent: "senza risultati?",
      // Flat form for aria-label / structured data.
      plain:
        "Da quanto tempo cerchi di parlare meglio in italiano senza risultati?",
    },
    /*
      One emphasis, not three. The paragraph used to carry a bold lockup, an
      italic run and a plain "congiuntivo" all competing inside five lines;
      the brand lockup is already stated by the eyebrow above, so the only
      emphasis left is the phrase the reader is meant to remember.
    */
    subtitle: {
      lead: "Con il metodo ALPS, un vero approccio science based per l'apprendimento dell'italiano, ti aiuto personalmente a comunicare in modo più ",
      emphasis: "corretto, fluente e sicuro",
      tail: ", usando anche il congiuntivo. Già dopo poche settimane cambierà il tuo modo di parlare.",
    },
    cta: "Candidati al percorso ALPS",
    // Short factual course markers, all taken from the FAQ and method copy:
    // "Il percorso dura 3 mesi", "non registrato ma live online",
    // "È richiesto almeno un livello B1".
    // Live teaching leads: it is the differentiator, not the duration.
    meta: [
      { icon: "live", value: "Lezioni live", label: "online, mai registrate" },
      { icon: "duration", value: "3 mesi", label: "di percorso" },
      { icon: "level", value: "Da B1", label: "livello richiesto" },
    ],
  },
  offerings: {
    title: {
      part1: "IL METODO ALPS, ",
      boldPart: "SCIENCE-BASED",
    },
    description: [
      {
        type: "bold",
        content: "ALPS ",
      },
      {
        type: "text",
        content: "significa ",
      },
      {
        type: "text",
        content: "Ascolta, Leggi, Parla, Scrivi. ",
      },
      { type: "text", content: "È un metodo " },
      { type: "bold", content: "science based" },
      {
        type: "text",
        content:
          ", di insegnamento della lingua italiana online con il quale guido personalmente studenti a livello intermedio/avanzato a imparare, davvero, a ",
      },
      { type: "text", content: "usare la lingua" },
      {
        type: "text",
        content:
          " e sentirsi soddisfatti quando parlano l'italiano. Questo metodo è dentro a un corso che dura 3 mesi, che si chiama: ",
      },
    ],
    courseName: "PERCORSO ALPS",
    subtitle: "PERCHÉ IL METODO ALPS FUNZIONA DAVVERO:",
    features: [
      {
        // OLD: icon: faHeadset,
        iconUrl: featureIcon1, // NEW: Use the imported image
        name: "4 Abilità Integrate",
        description:
          "Usi attivamente tutte e 4 le abilità (ascolto, lettura, parlato, scrittura) in una sequenza precisa che accelera l'apprendimento.",
        imageUrl: featureImg1,
      },
      {
        iconUrl: featureIcon2, // NEW
        name: "Apprendimento Attivo",
        description:
          "Non memorizzi regole: le applichi subito, così impari a usare strutture complesse in modo naturale.",
        imageUrl: featureImg2,
      },
      {
        iconUrl: featureIcon3, // NEW
        name: "Pratica Costante",
        description:
          "Non guardi un videocorso per imparare ma usi sempre la lingua, attivamente.",
        imageUrl: featureImg3,
      },
      {
        iconUrl: featureIcon4, // NEW
        name: "Correzioni Personalizzate",
        description:
          "Ricevi correzioni personalizzate, così l'errore diventa il tuo miglior alleato ed eviti di portare avanti gli stessi errori per anni.",
        imageUrl: featureImg4,
      },
      {
        iconUrl: featureIcon5, // NEW
        name: "Vocabolario Utile",
        description:
          "Espandi il vocabolario su tanti temi e impari ad affrontare dibattiti e temi attuali, non solo a descrivere la tua giornata.",
        imageUrl: featureImg5,
      },
      {
        iconUrl: featureIcon6, // NEW
        name: "Supporto Continuo",
        description:
          "Sei sempre accompagnato e monitorato da me: non sei mai solo e tutte le lezioni sono online, ma live.",
        imageUrl: featureImg6,
      },
      {
        iconUrl: featureIcon7, // NEW
        name: "Immersione Culturale",
        description:
          "Partecipi a incontri speciali con italiani madrelingua che ti fanno scoprire cultura, società e modi di pensare italiani.",
        imageUrl: featureImg7,
      },
    ],
    conclusion: {
      part1: "Queste sono ",
      boldPart: "basi scientifiche",
      part2:
        " di ogni approccio efficace all'apprendimento di una seconda lingua. Eppure non vengono mai usate tutte insieme in un solo corso.",
      part3:
        "Il PERCORSO ALPS, invece, le contiene tutte, per un apprendimento a 360° e veramente effettivo.",
    },
    cta: "Come candidarmi al Percorso ALPS?", //
  },
  about: {
    eyebrow: "Chi Sono",
    title: "PERCHÉ puoi fidarti di me:", // [cite: 992]
    // NEW COPY — adjust freely. Summarises the biography below it.
    subtitle:
      "Insegnante di italiano per stranieri, a scuola e online, da oltre dieci anni.",
    /*
      Header for the qualification block, which is now its own section rather
      than two cards appended to the biography. NEW COPY — built from the two
      panel titles it introduces ("… fa per te se:" / "… ti aiuterà a:").
    */
    fit: {
      eyebrow: "Percorso ALPS",
      title: "È il percorso giusto per te?",
      subtitle:
        "I requisiti per entrare nel percorso e i risultati che otterrai.",
    },
    introduction: [
      // Paragraph 1
      [
        {
          type: "text",
          content:
            "Mi chiamo Caterina e insegno italiano a studenti stranieri ",
        },
        { type: "bold", content: "da oltre 10 anni" },
        {
          type: "text",
          content:
            ", sia a scuola che online. Ho aiutato centinaia di studenti che ",
        },
        { type: "text", content: "conoscevano" },
        { type: "text", content: " bene " },
        { type: "text", content: "la grammatica" },
        { type: "text", content: ", ma si sentivano " },
        { type: "bold", content: "insicuri" },
        { type: "text", content: " e " },
        { type: "bold", content: "bloccati" },
        { type: "text", content: " quando dovevano " },
        { type: "text", content: "parlare" },
        { type: "text", content: "." },
      ],
      // Paragraph 2
      [
        {
          type: "text",
          content:
            "È frustrante conoscere le regole ma non riuscirle ad applicarle nel momento del bisogno, con il risultato che ",
        },
        { type: "bold", content: "ti senti inadeguato" },
        { type: "text", content: ", " },
        { type: "bold", content: "ti blocchi" },
        { type: "text", content: ", " },
        { type: "bold", content: "non sei soddisfatto" },
        {
          type: "text",
          content:
            ". So esattamente come ci si sente, perché anch'io ho imparato altre lingue e mi sono trovata nella stessa situazione.",
        },
      ],
      // Paragraph 3
      [
        {
          type: "text",
          content:
            "Proprio per aiutare gli studenti in questo, dopo anni di esperienza e osservazione, ho creato il ",
        },
        { type: "bold", content: "Metodo ALPS" },
        { type: "text", content: ": " },
        { type: "text", content: "Ascolta" },
        { type: "text", content: ", " },
        { type: "text", content: "Leggi" },
        { type: "text", content: ", " },
        { type: "text", content: "Parla" },
        { type: "text", content: ", " },
        { type: "text", content: "Scrivi" },
        {
          type: "text",
          content: " che ho inserito in un corso di 3 mesi che ",
        },
        {
          type: "text",
          content:
            "rivoluziona per sempre il tuo modo di approcciarti alla lingua italiana",
        },
        { type: "text", content: ": il " },
        { type: "bold", content: "PERCORSO ALPS" },
        { type: "text", content: "." },
      ],
    ],
    listIcon: CheckCircleIcon,
    isForYou: {
      title: "Il Percorso ALPS fa per te se:", // [cite: 999]
      points: [
        "Sei a un livello intermedio/avanzato.", // [cite: 1000]
        "Hai studiato la grammatica italiana, ma quando parli non riesci a usarla davvero.", // [cite: 1001]
        "Ti blocchi, hai paura di sbagliare, o ti esprimi in modo troppo semplice.", // [cite: 1002]
        "Capisci bene l'italiano quando ascolti e leggi, ma non ti senti sicuro nel parlarlo.", // [cite: 1003, 1006]
        "Non ricevi mai correzioni e quindi non sai dove sbagli.", // [cite: 1004]
        "Eviti il congiuntivo e le strutture complesse perché temi di usarle male.", // [cite: 1005]
        "Affronti l'apprendimento da solo, senza un metodo o una guida.", // [cite: 1007]
      ],
      imageUrl: isForYouBg,
    },
    willHelpYou: {
      title: "Il Percorso ALPS ti aiuterà a:", // [cite: 1008]
      points: [
        "Parlare con più padronanza, naturalezza e sicurezza.", // [cite: 1009]
        "Usare anche strutture complesse come il congiuntivo senza paura.", // [cite: 1010]
        "Espandere il vocabolario e scegliere le parole giuste al momento giusto.", // [cite: 1011]
        "Ricevere correzioni continue per capire davvero la lingua e dove sbagli.", // [cite: 1011]
        "Sviluppare la capacità di esprimere la tua opinione, su tanti argomenti.", // [cite: 1012]
        "Raggiungere i tuoi obiettivi con la lingua italiana, che siano per lavoro, studio o passione.", // [cite: 1013]
      ],
      imageUrl: willHelpYouBg,
    },
    conclusion:
      "Le candidature aprono solo 3 volte all'anno e i posti sono limitati.", // [cite: 1014]
    cta: "non perderti la prossima edizione", // [cite: 1015]
  },
  testimonials: {
    title: "COSA DICE CHI L'HA PROVATO:", // [cite: 1016]
    videos: [
      // [cite: 1017]
      {
        studentName: "Saray",
        description:
          "Nei corsi che ho fatto in passato non ho mai avuto un feedback",
        videoUrl: video1,
        posterUrl: posterVideo1,
      },
      {
        studentName: "Razan",
        description:
          "Prima del percorso non mi sentivo brava abbastanza, mi stavo giudicando tantissimo",
        videoUrl: video2,
        posterUrl: posterVideo2,
      },
      {
        studentName: "Aleksandra",
        description:
          "Grazie a questo percorso ho guadagnato la fiducia e la sicurezza nel parlare italiano",
        videoUrl: video3,
        posterUrl: posterVideo3,
      },
    ],
    subtitle: "COME SI SENTONO ORA:", // [cite: 1017]
    screenshots: [
      // [cite: 1018]
      // Intrinsic sizes are declared so the browser reserves the right space
      // before these lazy images load (no layout shift).
      {
        alt: "Testimonial screenshot 1",
        imageUrl: screenshot1,
        width: 1018,
        height: 1033,
      },
      {
        alt: "Testimonial screenshot 2",
        imageUrl: screenshot2,
        width: 1026,
        height: 939,
      },
      {
        alt: "Testimonial screenshot 3",
        imageUrl: screenshot3,
        width: 1031,
        height: 1158,
      },
    ],
    // conclusion:
    // "Da quanto tempo desideri parlare meglio in italiano? Giorni, mesi o forse anni? Invece di lasciarlo solo un desiderio possiamo farlo diventare un obiettivo reale da raggiungere insieme e la prossima edizione del PERCORSO ALPS potrebbe essere l'inizio del tuo cambiamento.", // [cite: 1019, 1020, 1021]
    cta: "compila il form per la prossima edizione", // [cite: 1023]
  },
  register: {
    eyebrow: "Lista d’attesa",
    // The section now leads with the decisive question and folds the previous
    // opening line into the supporting paragraph, so there is one headline
    // instead of two competing ones.
    title: "Pronto a iniziare il tuo cambiamento?",
    /*
      Split at the existing sentence boundary — not a word is changed. As one
      block it set as a five-line slab of undifferentiated sans; the opening
      question now carries the voice and the rest supports it.
    */
    lead: {
      question: "Da quanto tempo desideri parlare meglio in italiano?",
      part1:
        "Invece di lasciarlo un desiderio, possiamo farlo diventare un obiettivo reale da raggiungere insieme: la prossima edizione del ",
      boldPart: "PERCORSO ALPS",
      part2: " potrebbe essere l'inizio del tuo cambiamento.",
    },
    // The scarcity information that used to be buried under underlines.
    scarcity: {
      value: "3",
      unit: "candidature all’anno",
      points: ["Posti limitati", "Ingresso su selezione"],
    },
    form: {
      title: "Entra in lista d’attesa",
      subtitle:
        "Lascia la tua email: sarai il primo a sapere quando si apriranno le prossime iscrizioni.",
      fields: [
        {
          name: "name",
          label: "Nome",
          type: "text",
          placeholder: "Come ti chiami?",
          autoComplete: "given-name",
          // A given name should arrive capitalised, and the return key should
          // advance to the email rather than submit a half-filled form.
          autoCapitalize: "words",
          enterKeyHint: "next",
        },
        {
          name: "email",
          label: "Email",
          type: "email",
          placeholder: "nome@esempio.com",
          autoComplete: "email",
          // Android keyboards still capitalise and autocorrect an email field
          // unless told otherwise, which silently corrupts the address.
          inputMode: "email",
          autoCapitalize: "none",
          autoCorrect: "off",
          spellCheck: false,
          enterKeyHint: "send",
        },
      ],
      buttonText: "Avvisami",
      buttonBusyText: "Invio in corso…",
      gdprConsentText:
        "Lasciando il tuo indirizzo email, acconsenti a ricevere comunicazioni informative nel rispetto del GDPR. Potrai cancellarti in qualsiasi momento.",
      errors: {
        name: "Inserisci il tuo nome.",
        email: "Inserisci un indirizzo email valido.",
        consent: "Per procedere, accetta il consenso GDPR.",
        duplicate: "Questa email risulta già registrata.",
        generic: "C'è stato un errore. Riprova più tardi.",
      },
    },
    success: {
      title: "Grazie!",
      message: "Ti avviseremo non appena le iscrizioni apriranno.",
      nextStepText: "Nel frattempo, leggi le domande frequenti",
    },
  },
  masterclass: {
    badge: "Masterclass live",
    title: "Iscriviti alla prossima Masterclass ALPS",
    subtitle:
      "Un incontro intensivo e gratuito per scoprire come usare il Metodo ALPS per migliorare il tuo italiano in modo scientifico.",
    details: [
      "Posti limitati, pensato per piccoli gruppi.",
      "Sessione live con spazio per domande e risposte.",
      "Riceverai il link Zoom e il promemoria via email.",
    ],
    form: {
      title: "Prenota il tuo posto",
      subtitle:
        "Compila il form qui sotto per ricevere data, orario e link della prossima edizione.",
      buttonText: "Iscriviti alla lista di attesa",
      successMessage:
        "Grazie! Ti invieremo i dettagli della prossima masterclass direttamente via email.",
      gdprConsentText:
        "Acconsento al trattamento dei miei dati per ricevere comunicazioni relative alla masterclass e al percorso ALPS.",
      fields: {
        name: {
          label: "Nome e cognome",
          placeholder: "Come ti chiami?",
        },
        email: {
          label: "Email",
          placeholder: "Inserisci la tua email",
        },
        phone: {
          label: "Numero di telefono",
          placeholder: "Inserisci il tuo numero (opzionale)",
        },
        languageLevel: {
          label: "Il tuo livello di italiano",
          placeholder: "Seleziona un'opzione",
        },
        reason: {
          label: "Perché vuoi partecipare alla masterclass?",
          placeholder: "Raccontaci il motivo della tua candidatura...",
        },
      },
    },
  },
  contact: {
    title: "Connect With Us",
    subheading: "Reach out to start your Italian learning adventure today!",
    successMessage: "Message sent successfully!",
    details: {
      email: "info@italianteacher.com",
      phone: "+1 (555) 123-4567",
      emailIcon: EmailIcon,
      phoneIcon: PhoneIcon,
      socials: [
        { platform: "Twitter", url: "https://twitter.com", icon: TwitterIcon },
        {
          platform: "LinkedIn",
          url: "https://linkedin.com",
          icon: LinkedInIcon,
        },
        {
          platform: "Instagram",
          url: "https://instagram.com/learnitalianwithcaterina",
          icon: InstagramIcon,
        },
      ],
    },
  },
  faq: {
    title: "Domande Frequenti",
    subtitle: "Trova le risposte alle domande più comuni sul Percorso ALPS",
    questions: [
      {
        question: "Il Percorso ALPS è un videocorso?",
        answer: "No. Il Percorso ALPS è un percorso non registrato ma live online. Le lezioni sono in diretta e Caterina segue personalmente tutti gli studenti, aiutandoli a migliorare concretamente nel modo in cui parlano e scrivono in italiano."
      },
      {
        question: "Quanto dura il Percorso ALPS?",
        answer: "Il percorso dura 3 mesi. È un corso intensivo in cui è richiesto un certo impegno. Ci si incontra ogni settimana e sono previste attività da svolgere sia prima sia dopo le lezioni, per consolidare e rendere attivo l'apprendimento."
      },
      {
        question: "Che risultati posso ottenere con il Percorso ALPS?",
        answer: "Migliorerai la comprensione orale e scritta, parlerai con maggiore fluenza e sicurezza e imparerai a usare davvero strutture complesse come congiuntivo, periodo ipotetico e concordanza dei tempi, con un vocabolario più ricco e preciso."
      },
      {
        question: "Come faccio a capire se sono al livello giusto?",
        answer: "La valutazione viene fatta da Caterina tramite un questionario e la registrazione di un breve audio. Dopodiché farà un colloquio con ogni studente. È richiesto almeno un livello B1."
      },
      {
        question: "Nel percorso ALPS si viene seguiti personalmente da Caterina?",
        answer: "Sì, Caterina fa tutte le selezioni degli studenti, è lei l'insegnante che fa le lezioni live online e che anima l'interno percorso; ha un rapporto individuale con ognuno degli studenti nel percorso, conosce la situazione linguistica di ognuno e dà consigli mirati e personalizzati ad ogni studente."
      },
      {
        question: "Essere in lista d'attesa garantisce l'accesso al corso?",
        answer: "No. La lista d'attesa permette di essere avvisati prima dell'apertura ufficiale delle candidature, ma l'accesso al percorso avviene sempre dopo una selezione, per garantire un gruppo omogeneo e un lavoro efficace."
      },
    ],
  },
  footer: {
    logoUrl: logoUrl,
    logoTitle: "MetodoALPS",
    description:
      "Un passo alla volta, con impegno costante, ti aiuto a diventare un bravo parlante.",
    quickLinks: [
      { name: "Home", to: "home" },
      { name: "Metodo", to: "offerings" },
      { name: "Chi Sono", to: "about" },
      { name: "Per Chi È", to: "per-chi" },
      { name: "Testimonianze", to: "testimonials" },
      { name: "Iscriviti", to: "register" },
    ],
    /*
      Instagram is the real audience, so it is a named link with the handle
      rather than one anonymous icon in a row. The LinkedIn entry was a
      placeholder URL and has been removed.
    */
    social: {
      platform: "Instagram",
      label: "Seguimi su Instagram", // NEW COPY — adjust freely.
      handle: "@learnitalianwithcaterina",
      url: "https://instagram.com/learnitalianwithcaterina",
      icon: InstagramIcon,
    },
    copyright: `© ${new Date().getFullYear()} Caterina Imola. Tutti i diritti riservati.`,
  },
};
